/*
 *  jq-accordion - vv1.0.0
 *  Responsive, CSS powered, jQuery accordion plugin
 *  http://nayzawoo.github.com/jquery-accordion
 *
 *  (c) 2014 Victor Fernandez <victor@vctrfrnndz.com>
 *  (c) 2016 Nay Zaw Oo <nayzawoo.me@gmail.com>
 *  Under MIT License
 */
"use strict";

!function (a, b, c, d) {
  function e(b, c) {
    this.element = b, this.options = a.extend({}, g, c), this._defaults = g, this._name = f, this.init();
  }

  var f = "accordion",
      g = {
    transitionSpeed: 300,
    transitionEasing: "ease",
    controlElement: "[data-control]",
    contentElement: "[data-content]",
    groupElement: "[data-accordion-group]",
    singleOpen: !0
  };
  e.prototype.init = function () {
    function d(a, b, c) {
      var d;
      return function () {
        function e() {
          c || a.apply(f, g), d = null;
        }

        var f = this,
            g = arguments;
        d ? clearTimeout(d) : c && a.apply(f, g), d = setTimeout(e, b || 100);
      };
    }

    function e() {
      var a = c.body || c.documentElement,
          b = a.style,
          d = "transition";
      if ("string" == typeof b[d]) return !0;
      var e = ["Moz", "webkit", "Webkit", "Khtml", "O", "ms"];
      d = "Transition";

      for (var f = 0; f < e.length; f++) {
        if ("string" == typeof b[e[f] + d]) return !0;
      }

      return !1;
    }

    function f(a) {
      return b.requestAnimationFrame || b.webkitRequestAnimationFrame || b.mozRequestAnimationFrame ? b.requestAnimationFrame(a) || b.webkitRequestAnimationFrame(a) || b.mozRequestAnimationFrame(a) : setTimeout(a, 1e3 / 60);
    }

    function g(a, b) {
      b ? u.css({
        "-webkit-transition": "",
        transition: ""
      }) : u.css({
        "-webkit-transition": "max-height " + r.transitionSpeed + "ms " + r.transitionEasing,
        transition: "max-height " + r.transitionSpeed + "ms " + r.transitionEasing
      });
    }

    function h(b) {
      var c = 0;
      b.children().each(function () {
        c += a(this).outerHeight(!0);
      }), b.data("oHeight", c);
    }

    function i(b, c, d, e) {
      var f,
          g = b.filter(".open").find("> [data-content]"),
          h = g.find("[data-accordion].open > [data-content]");
      r.singleOpen || (h = h.not(c.siblings("[data-accordion].open").find("> [data-content]"))), f = g.add(h), b.hasClass("open") && f.each(function () {
        var b = a(this).data("oHeight");

        switch (e) {
          case "+":
            a(this).data("oHeight", b + d);
            break;

          case "-":
            a(this).data("oHeight", b - d);
            break;

          default:
            throw "updateParentHeight method needs an operation";
        }

        a(this).css("max-height", a(this).data("oHeight"));
      });
    }

    function j(a) {
      if (a.hasClass("open")) {
        var b = a.find("> [data-content]"),
            c = b.find("[data-accordion].open > [data-content]"),
            d = b.add(c);
        h(d), d.css("max-height", d.data("oHeight"));
      }
    }

    function k(a, b) {
      if (a.trigger("accordion.close"), y) {
        if (w) {
          var c = a.parents("[data-accordion]");
          i(c, a, b.data("oHeight"), "-");
        }

        b.css(x), a.removeClass("open");
      } else b.css("max-height", b.data("oHeight")), b.animate(x, r.transitionSpeed), a.removeClass("open");
    }

    function l(a, b) {
      if (a.trigger("accordion.open"), y) {
        if (g(b), w) {
          var c = a.parents("[data-accordion]");
          i(c, a, b.data("oHeight"), "+");
        }

        f(function () {
          b.css("max-height", b.data("oHeight"));
        }), a.addClass("open");
      } else b.animate({
        "max-height": b.data("oHeight")
      }, r.transitionSpeed, function () {
        b.css({
          "max-height": "none"
        });
      }), a.addClass("open");
    }

    function m(b) {
      var c = b.siblings("[data-accordion]").filter(".open"),
          d = c.find("[data-accordion]").filter(".open"),
          e = c.add(d);
      e.each(function () {
        var b = a(this),
            c = b.find(r.contentElement);
        k(b, c);
      }), e.removeClass("open");
    }

    function n() {
      var a = !!r.singleOpen && s.parents(r.groupElement).length > 0;
      h(u), a && m(s), s.hasClass("open") ? k(s, u) : l(s, u);
    }

    function o() {
      t.on("click", n), t.on("accordion.toggle", function () {
        return !(r.singleOpen && t.length > 1) && void n();
      }), a(b).on("resize", d(function () {
        j(s);
      }));
    }

    function p() {
      u.each(function () {
        var b = a(this);
        0 !== b.css("max-height") && (b.closest("[data-accordion]").hasClass("open") ? (g(b), h(b), b.css("max-height", b.data("oHeight"))) : b.css({
          "max-height": 0,
          overflow: "hidden"
        }));
      }), s.attr("data-accordion") || (s.attr("data-accordion", ""), s.find(r.controlElement).attr("data-control", ""), s.find(r.contentElement).attr("data-content", ""));
    }

    var q = this,
        r = q.options,
        s = a(q.element),
        t = s.find("> " + r.controlElement),
        u = s.find("> " + r.contentElement),
        v = s.parents("[data-accordion]").length,
        w = v > 0,
        x = {
      "max-height": 0,
      overflow: "hidden"
    },
        y = e();
    p(), o();
  }, a.fn[f] = function (b) {
    return this.each(function () {
      a.data(this, "plugin_" + f) || a.data(this, "plugin_" + f, new e(this, b));
    });
  };
}(jQuery, window, document);